import { render, staticRenderFns } from "./FactsList.vue?vue&type=template&id=10e8c34e&"
import script from "./FactsList.vue?vue&type=script&lang=js&"
export * from "./FactsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports